import { Controller } from "stimulus";
import { gsap } from "gsap";

export default class extends Controller {
  connect() {
    const lines  = this.element.querySelectorAll(".map-location-line");
    const labels = this.element.querySelectorAll(".map-location-label");

    lines.forEach((line) => {
      const length = line.getTotalLength ? line.getTotalLength() : 300;
      gsap.set(line, { strokeDasharray: length, strokeDashoffset: length });
    });

    gsap.set(labels, { opacity: 0 });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const tl = gsap.timeline();

            const spokane  = { line: lines[1],  label: labels[1] };
            const pergamino = { line: lines[0], label: labels[0] };

            // Spokane primero
            tl.to(spokane.line,  { strokeDashoffset: 0, duration: 0.9, ease: "power2.inOut" }, 0);
            tl.to(spokane.label, { opacity: 1, duration: 0.6, ease: "power2.out" }, "-=0.3");

            // Pergamino 2 segundos después
            tl.to(pergamino.line,  { strokeDashoffset: 0, duration: 0.9, ease: "power2.inOut" }, "+=0.2");
            tl.to(pergamino.label, { opacity: 1, duration: 0.6, ease: "power2.out" }, "-=0.3");

            observer.unobserve(this.element);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(this.element);
  }
}
